import { useMemo } from "react";
import { useGetAnalysisProfilesQuery } from "../assessmentsSlice";
import getOptions from "../../../utils/getOptions";
import useLang from "../../../hooks/useLang";

const useProfileIdBlock = () => {
  const lang = useLang();
  const profiles = useGetAnalysisProfilesQuery();
  const profileOptions = useMemo(() => {
    return getOptions(profiles?.data ?? [], "name");
  }, [profiles?.data]);

  const items = profiles?.isLoading
    ? [
        {
          id: "label",
          type: "label",
          value: lang("reports.profiles_loading"),
        },
      ]
    : [
        {
          id: "label",
          type: "label",
          value: lang("reports.select_profile"),
        },
        {
          id: "analysis_profile_id",
          type: "dropdown-selector",
          options: profileOptions,
          required: true,
          idAsValue: true,
          label: null,
        },
      ];

  return {
    sections: [{ items }],
  };
};

export default useProfileIdBlock;
